<template>
  <transition
    name="dialog-fade"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <div
      v-show="visibleNew"
      :class="'el-dialog__wrapper ' + confirmDialogClass"
      :id="id"
      @click.self="handleWrapperClick"
    >
      <div
        role="dialog"
        :key="key"
        aria-modal="true"
        :aria-label="title || 'dialog'"
        :class="[
          'el-dialog',
          { 'is-fullscreen': fullscreen, 'el-dialog--center': center },
          customClass
        ]"
        ref="dialog"
        :style="style"
      >
        <div class="el-dialog__header">
          <slot name="title">
            <span class="el-dialog__title">{{ title }}</span>
          </slot>
          <button
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            v-if="showClose"
            @click="handleClose"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="el-dialog__body" style="padding: 15px 20px;">
          <div v-html="message"></div>
        </div>
        <div class="el-dialog__footer">
          <span class="dialog-footer">
            <el-button
              :class="cancelAcClass"
              :style="cancelAcStyle"
              @click="cancelAcPlugin"
              size="small"
              >{{ cancelAcText.length > 0 ? cancelAcText : "取 消" }}</el-button
            >
            <el-button
              :class="confirmAcClass"
              :style="confirmAcStyle"
              size="small"
              @click="confirmAcPlugin"
              >{{
                confirmAcText.length > 0 ? confirmAcText : "确 定"
              }}</el-button
            >
          </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from "../../../src/utils/popup";
import Migrating from "../../../src/mixins/migrating";
import emitter from "../../../src/mixins/emitter";

export default {
  name: "ElDialog",

  mixins: [Popup, emitter, Migrating],

  props: {
    title: {
      type: String,
      default: ""
    },

    confirmDialogClass: {
      type: String,
      default: ""
    },

    cancelAcClass: {
      type: String,
      default: ""
    },

    cancelAcStyle: {
      type: String,
      default: ""
    },

    confirmAcClass: {
      type: String,
      default: ""
    },

    confirmAcStyle: {
      type: String,
      default: ""
    },

    modal: {
      type: Boolean,
      default: true
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: false
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    width: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ""
    },

    top: {
      type: String,
      default: "15vh"
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    },

    destroyOnClose: {
      type: Boolean,
      default: true
    },
    cancelAcText: String,
    confirmAcText: String,
    confirmAc: Function,
    cancelAc: Function,
    message: String
  },

  data() {
    return {
      closed: false,
      visibleNew: false,
      key: 0
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.closed = false;
        this.$emit("open");
        this.$el.addEventListener("scroll", this.updatePopper);
        this.$nextTick(() => {
          this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener("scroll", this.updatePopper);
        if (!this.closed) this.$emit("close");
        if (this.destroyOnClose) {
          this.$nextTick(() => {
            this.key++;
          });
        }
      }
    }
  },

  computed: {
    style() {
      let style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (this.width) {
          style.width = this.width;
        }
      }
      return style;
    }
  },

  methods: {
    getMigratingConfig() {
      return {
        props: {
          size: "size is removed."
        }
      };
    },
    handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose() {
      this.visibleNew = false;
      this.close();
      // const id = this.id;
      // setTimeout(() => {
      //   document.getElementById(id).remove();
      //   document.getElementsByClassName("v-modal").forEach(element => {
      //     element.remove();
      //   });
      // }, 1000);
      if (typeof this.beforeClose === "function") {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide(cancel) {
      if (cancel !== false) {
        this.$emit("update:visible", false);
        this.$emit("close");
        this.closed = true;
      }
    },
    updatePopper() {
      this.broadcast("ElSelectDropdown", "updatePopper");
      this.broadcast("ElDropdownMenu", "updatePopper");
    },
    afterEnter() {
      this.$emit("opened");
    },
    afterLeave() {
      this.$emit("closed");
    },
    cancelAcPlugin() {
      this.handleClose();
      if (typeof this.cancelAc === "function") {
        this.cancelAc();
      }
    },
    confirmAcPlugin() {
      this.handleClose();
      if (typeof this.confirmAc === "function") {
        this.confirmAc();
      }
    }
  },

  mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  created() {
    this.visibleNew = this.visible;
  },

  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
